import script from "./counter.vue?vue&type=script&setup=true&lang=js"
export * from "./counter.vue?vue&type=script&setup=true&lang=js"

import "./counter.vue?vue&type=style&index=0&id=33b75ef3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33b75ef3"]])

export default __exports__